<form [formGroup]="form_translate" class="kt-form kt-form--label-right live-translate">
    Agent language 
        <ng-select [items]="translations_languages"
            bindLabel="name"
            bindValue="code"
            labelForId="language_agent"
            formControlName="language_agent">
        </ng-select>
    
        <span [inlineSVG]="'Navigation/Up-down.svg'" class="bi-direction svg-primary" title="Two-way Translation"></span>

        Visitor language
        <span [hidden]="!(is_loading_detect_language$ | async)" class="kt-spinner kt-spinner--v2 kt-spinner--sm kt-spinner--brand"></span>

        <ng-select [items]="translations_languages" 
            bindLabel="name"
            bindValue="code"
            labelForId="language_visitor"
            formControlName="language_visitor">
        </ng-select>  

        <div class="kt-align-right kt-margin-t-10">
            <span class="kt-margin-r-10"><a href="javascript:void(0)" (click)="popover.close(); stop_translation()" class="kt-link kt-font-bold">Turn Off</a> or</span>
            <button class="btn btn-brand" (click)="popover.close(); apply_translation()" type="button">Apply</button>		
        </div>

</form>